import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { filter, find, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import * as CareerCard from '@components/LibraryProgramsCareer';
import * as BadgeCard from '@components/LibraryProgramsBadge';
import * as CertificateCard from '@components/LibraryProgramsCertification';
import { AppActions, DevelopActions } from '~/actions';
import { ProgramTypes } from '~/services/config';

class ProgramDetail extends Component {
    constructor(props) {
        super(props);
        const type = props.match?.params?.activeTab;
        const id = Number(props.match?.params?.id || 0);
        const { templates } = props;
        const program = templates[type]?.data ? find(propEq('id', id), templates[type].data) : null;
        this.state = { id, type, program };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { match, templates } = nextProps;
        if (!match?.params) {
            return null;
        }
        const type = match.params.activeTab;
        const id = Number(match.params.id);
        if (id !== prevState.id) {
            const program = templates[type]?.data ? find(propEq('id', id), templates[type].data) : null;
            return { id, type, program };
        }
        return null;
    }

    handleSelectMenu = (e) => {
        const { type, program } = this.state;
        const { companyId } = this.props;
        const disabled = filter((e) => e !== type, ProgramTypes);

        switch (e) {
            case 'assign':
                this.props.toggleModal({
                    type: 'Assign Program',
                    data: {
                        before: { modules: [program], disabled, levels: program.data.levels, companyId },
                        after: this.props.getProgramDetail(program, type),
                    },
                });
                break;
            case 'detail view':
                this.props.navigate(`/library/programs/${type}/${program.id}/view`);
                break;
            case 'edit':
                this.props.navigate(`/library/programs/${type}/${program.id}/edit`);
                break;
            case 'quick assign':
                this.props.toggleModal({
                    type: 'Quick Assign',
                    data: {
                        before: { template: program, type: 'Program', from: 'template', companyId },
                    },
                });
                break;
            default:
                break;
        }
    };

    render() {
        const { role, companyId, authors, departments, competencies, categories, companies } = this.props;
        const { program, type } = this.state;
        const company = find(propEq('id', companyId), companies);
        const jobRoles = company.job_roles;

        return (
            <ErrorBoundary>
                <Filter back={`all ${type === 'careers' ? 'Health Plan' : type}`} />
                {type === 'careers' && (
                    <CareerCard.Detail
                        data={program}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        userRole={role}
                        jobs={jobRoles}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e) => this.props.saveProgram(e)}
                        onSelect={this.handleSelectMenu}
                    />
                )}
                {type === 'certifications' && (
                    <CertificateCard.Detail
                        userRole={role}
                        data={program}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        jobs={jobRoles}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e) => this.props.saveProgram(e)}
                        onSelect={this.handleSelectMenu}
                    />
                )}
                {type === 'badges' && <BadgeCard.Detail data={program} />}
            </ErrorBoundary>
        );
    }
}

ProgramDetail.propTypes = {
    role: PropTypes.number,
    templates: PropTypes.any,
    authors: PropTypes.array,
    categories: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    saveProgram: PropTypes.func,
    toggleModal: PropTypes.func,
    getProgramDetail: PropTypes.func,
};

ProgramDetail.defaultProps = {
    role: 1,
    templates: {},
    authors: [],
    categories: [],
    departments: [],
    competencies: [],
    saveProgram: () => {},
    toggleModal: () => {},
    getProgramDetail: () => {},
};

const mapStateToProps = (state) => ({
    role: state.app.app_role_id,
    companyId: state.app.company_info.id,
    templates: state.develop.templates,
    authors: state.app.authors,
    categories: state.app.categories,
    departments: state.app.departments,
    competencies: state.app.competencies,
    companies: state.app.companies,
});

const mapDispatchToProps = (dispatch) => ({
    saveProgram: (e) => dispatch(DevelopActions.librarysaveRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
    getProgramDetail: (payload, type) => dispatch(DevelopActions.libraryprogramdetailRequest(payload, type, null)),
});

// HOC to provide React Router v6 params to class component
const withRouterParams = (Component) => {
    return (props) => {
        const params = useParams();
        const match = { params };
        return <Component {...props} match={match} />;
    };
};

const ProgramDetailWithRouter = withRouterParams(connect(mapStateToProps, mapDispatchToProps)(ProgramDetail));

export default ProgramDetailWithRouter;
